export default {
  white: '#fff',
  black: '#000',
  red: '#d32b53',
  blue: '#465bae',
  lighterGray: '#1f3340',
  dark: '#1c1c1c',
  gray: '#f7f7f7',
  brown: '#1f3340',
  darkWhite: '#aeaeae',
  baseBlue: '#42a5f5',
  hitGray: '#acb6bd',
  alto: '#dfdfdf',
  nobel: '#b7b7b7',
  riverBed: '#4a575d',
  ceriseRed: '#d92c4e',
  mercury: '#e6e6e6',
  blackTransparent: 'rgba(0, 0, 0, 0)',
  bgVideoPopup: 'rgba(0, 0, 0, 0.8)',

  btnHeader: '#d32b53',
  btnProcess: '#465bae',
  btnFooter: '#42a5f5',
  btnGameDetail: '#1c1c1c',

  bgBanner: 'rgba(0, 0, 0, 0.3)',
  bgContact: '#42a5f5',
  bgFooter: '#4a4a4a',
  bgProcess: '#fbfbfb',
  bgService: '#465bae',
  bgTeam: '#d32b53',
  bgTestimonials: '#3356a6',
  bgtransparent: 'transparent',
  bgArrow: 'rgba(31, 51, 64, 0.25)',
  bgImage: '#d8d8d8',
  mineShaft: '#242424',

  borderAboutUs: '#e6e6e6',
  borderHeader: '#ddd',

  descriptionGame: '#acb6bd',
  boxShadowAboutUs: '#bfbfbf',

  bgGameDetail: 'rgba(255, 255, 255, 0.8)',
  boxShadowPrimary: 'rgba(0, 0, 0, 0.1)',
  boxShadowImage: 'rgba(148, 148, 148, 0.5)',
  boxShadowSideBar: 'rgba(0, 0, 0, 0.3)',

  // Modal
  bgBackdrop: 'rgba(0, 0, 0, .5)',
  bgDialog: '#f8f8f8',
  colorDialog: '#0a2630',
  titleDialog: '#4a575d',
  bgSendProcess: 'rgba(74, 87, 93, .3)',

  // Footer
  colorAddress: '#d8d8d8',
  bgFacebook: '#3d53ab',
  bgTwitter: '#9ccfd4',
  bgLinkedin: '#007bb6',
  bgEmail: '#74187f',
  bgGoodFirms: '#1f1f1f'
}



// WEBPACK FOOTER //
// ./src/themes/Colors.js